import type { SvgIconProps } from '@mui/material/SvgIcon';
import type * as React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

export const WarningIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 16 16">
            <polygon fill="none" stroke="currentColor" strokeMiterlimit="10" points="8,1.5 1,15.5 15,15.5"/>
            <circle cx="8" cy="12.583" r="1"/>
            <polygon points="7,7 9,7 8,11"/>
        </SvgIcon>
    );
};